export default 
{
  type: "form-rating",
  style: "",
  data: {
    label: "How likely are you to recommend us to a friend or colleague?",
    lowRatingLabel: "Strongly Disagree",
    highRatingLabel: "Strongly Agree",
    ratingStyle: "number",
    ratingLevel: 5,
  },
  children: [],
};
